/* ONSRA cookie consent (Grok Bot 01.11.2026, compact redesign + decline-denies-all fix 01.11.2026), replaces Pandectes. Shopify Customer Privacy API + Google Consent Mode v2.
   Mode from config: 'optout' (US) = notice + opt-out ("Do not sell or share"), GPC respected; visitors in Shopify consent regions (EU/UK/CH etc.) get opt-in.
   Choice stored in cookie onsra_consent (necessary) + Shopify's own consent cookie. Reopen: [data-onsra-consent-open] or a[href$="#cookie-settings"]. */
(function(w,d){
  'use strict';
  var cfgEl=d.getElementById('occ-cfg'); if(!cfgEl||w.__occ) return; w.__occ=1;
  var cfg; try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
  var T=cfg.t, VER=1, CK='onsra_consent';
  var EEA=['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IS','IE','IT','LV','LI','LT','LU','MT','NL','NO','PL','PT','RO','SK','SI','ES','SE','GB','CH'];
  var gpc=w.navigator.globalPrivacyControl===true;
  var mode=cfg.mode==='optin'?'optin':'optout', root, card, state=null, cp=null, cpWait=[];

  function dl(){ (w.dataLayer=w.dataLayer||[]).push(arguments); }
  function readC(){ try{ var m=d.cookie.match(/(?:^|; )onsra_consent=([^;]*)/); var c=m&&JSON.parse(decodeURIComponent(m[1])); return c&&c.v===VER?c:null; }catch(e){ return null; } }
  function writeC(c){ d.cookie=CK+'='+encodeURIComponent(JSON.stringify(c))+';path=/;max-age=31536000;SameSite=Lax'+(location.protocol==='https:'?';Secure':''); }
  function gUpdate(c){ var G='granted',D='denied'; dl('consent','update',{ad_storage:c.m?G:D,ad_user_data:c.m?G:D,ad_personalization:c.m?G:D,analytics_storage:c.a?G:D,functionality_storage:c.p?G:D,personalization_storage:c.p?G:D}); }

  function withCP(cb){
    if(cp!==null) return cb(cp);
    cpWait.push(cb); if(cpWait.length>1) return;
    var tries=0;
    (function boot(){
      var S=w.Shopify;
      if(S&&S.customerPrivacy&&S.customerPrivacy.setTrackingConsent) return done(S.customerPrivacy);
      if(S&&typeof S.loadFeatures==='function'){ S.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){ done(err?null:w.Shopify.customerPrivacy); }); return; }
      if(++tries<60) return setTimeout(boot,100);
      done(null);
    })();
    function done(api){ cp=api||false; var q=cpWait; cpWait=[]; q.forEach(function(f){ try{f(cp);}catch(e){} }); }
  }
  function toShopify(c){
    withCP(function(api){
      if(!api) return;
      var p={analytics:!!c.a,marketing:!!c.m,preferences:!!c.p,sale_of_data:!!c.s};
      try{ api.setTrackingConsent(p,function(r){ if(r&&r.error){ delete p.sale_of_data; try{ api.setTrackingConsent(p,function(){}); }catch(e){} } }); }catch(e){}
    });
  }
  function shopifyState(api){
    try{ var v=api.currentVisitorConsent&&api.currentVisitorConsent(); if(!v) return null;
      if(!v.analytics&&!v.marketing&&!v.preferences) return null;
      return {v:VER,a:v.analytics==='yes'?1:0,m:v.marketing==='yes'?1:0,p:v.preferences==='yes'?1:0,s:v.sale_of_data==='no'?0:(v.marketing==='yes'?1:0),src:'shopify'};
    }catch(e){ return null; }
  }
  function differs(c,api){ try{ var v=api.currentVisitorConsent(); return v.analytics!==(c.a?'yes':'no')||v.marketing!==(c.m?'yes':'no')||v.preferences!==(c.p?'yes':'no'); }catch(e){ return false; } }

  function decide(c,why){
    if(gpc&&mode==='optout'){ c.m=0; c.s=0; }
    c.v=VER; c.t=Date.now(); c.mode=mode; c.src=why;
    state=c; writeC(c); gUpdate(c);
    dl({event:'onsra_consent_update',onsra_consent:{analytics:!!c.a,marketing:!!c.m,preferences:!!c.p,sale_of_data:!!c.s}});
    toShopify(c); hide();
  }

  function esc(s){ return String(s).replace(/[&<>"]/g,function(ch){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];}); }
  function row(id,lab,always){
    return '<div class="occ__row"><div><b id="occ-l-'+id+'">'+esc(lab[0])+'</b><span>'+esc(lab[1])+'</span></div>'+
      (always?'<em class="occ__aw">'+esc(T.always)+'</em>':'<label class="occ__sw"><input type="checkbox" role="switch" data-k="'+id+'" aria-labelledby="occ-l-'+id+'"><i></i></label>')+'</div>';
  }
  function build(){
    if(root) return;
    var o=mode==='optout';
    root=d.createElement('div'); root.id='occ'; root.className='occ'; root.hidden=true;
    root.innerHTML='<div class="occ__card" role="dialog" aria-modal="false" aria-label="'+esc(T.lbl)+'" aria-describedby="occ-d" tabindex="-1">'+
      '<p class="occ__d" id="occ-d">'+esc(o&&T.us_text?T.us_text:T.text)+' <a href="'+esc(cfg.policy)+'">'+esc(T.policy)+'</a></p>'+
      '<p class="occ__gpc"'+(gpc&&o&&T.gpc?'':' hidden')+'>'+esc(T.gpc)+'</p>'+
      '<div class="occ__p" id="occ-p"><div>'+row('n',T.nec,true)+row('p',T.pref)+row('a',T.ana)+row('m',T.mkt)+'</div></div>'+
      '<div class="occ__b-w">'+
        '<button type="button" class="occ__b" data-occ="reject">'+esc(T.reject)+'</button>'+
        '<button type="button" class="occ__b" data-occ="accept">'+esc(T.accept)+'</button>'+
      '</div>'+
      '<div class="occ__x"><button type="button" class="occ__l" data-occ="settings" aria-expanded="false" aria-controls="occ-p">'+esc(T.settings)+'</button>'+
        '<button type="button" class="occ__l occ__l--s" data-occ="save" hidden>'+esc(T.save)+'</button></div>'+
      '</div>';
    d.body.appendChild(root); card=root.firstChild;
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-occ]'); if(!b) return;
      var a=b.getAttribute('data-occ');
      if(a==='accept') decide({a:1,m:1,p:1,s:1},'accept');
      else if(a==='reject') decide({a:0,m:0,p:0,s:0},'reject');
      else if(a==='settings') prefs(!root.classList.contains('is-prefs'));
      else if(a==='save'){ var c={}; root.querySelectorAll('input[data-k]').forEach(function(i){ c[i.getAttribute('data-k')]=i.checked?1:0; }); c.s=c.m; decide(c,'save'); }
    });
    root.addEventListener('keydown',function(e){ if(e.key==='Escape'&&state) hide(); });
  }
  function sync(){
    var c=state||(mode==='optout'?{a:1,m:gpc?0:1,p:1}:{a:0,m:0,p:0});
    root.querySelectorAll('input[data-k]').forEach(function(i){ var k=i.getAttribute('data-k'); i.checked=!!c[k]; i.disabled=false; if(k==='m'&&gpc&&mode==='optout'){ i.checked=false; i.disabled=true; } });
  }
  function prefs(on){
    root.classList.toggle('is-prefs',on);
    var s=root.querySelector('[data-occ="settings"]'); s.setAttribute('aria-expanded',on?'true':'false'); s.textContent=on?T.close_settings:T.settings;
    root.querySelector('[data-occ="save"]').hidden=!on;
  }
  var hideT;
  function show(withPrefs,focus){
    build(); sync(); clearTimeout(hideT);
    root.hidden=false; root.classList.remove('is-out'); prefs(!!withPrefs);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-in'); if(focus) card.focus({preventScroll:true}); }); });
  }
  function hide(){
    if(!root||root.hidden) return;
    root.classList.remove('is-in'); root.classList.add('is-out');
    hideT=setTimeout(function(){ root.hidden=true; root.classList.remove('is-out','is-prefs'); },420);
  }

  d.addEventListener('click',function(e){
    var el=e.target.closest&&e.target.closest('[data-onsra-consent-open],a[href$="#cookie-settings"]'); if(!el) return;
    e.preventDefault(); show(true,true);
  });

  function init(){
    state=readC();
    if(state){ withCP(function(api){ if(api&&differs(state,api)) toShopify(state); }); return; }
    withCP(function(api){
      if(state) return;
      var s=api&&shopifyState(api);
      if(s){ state=s; writeC(s); gUpdate(s); return; }   // consent already given (e.g. earlier / at checkout)
      try{ if(api&&api.shouldShowBanner&&api.shouldShowBanner()) mode='optin'; }catch(e){}
      try{ var rg=String(api&&api.getRegion&&api.getRegion()||'').slice(0,2).toUpperCase(); if(EEA.indexOf(rg)>-1) mode='optin'; }catch(e){}
      if(mode==='optout') return;   // US opt-out regions: no banner; choices via footer "Your Privacy Choices"
      show(false,false);
    });
  }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',init); else init();
  w.onsraConsent={open:function(){show(true,true);},get:function(){return state;}};
})(window,document);
